import { AdminProjects } from '@platform/client';
import { useParams } from 'wouter';
import { AdminDetailPage, DetailPageAction } from '../../AdminDetailPage';
import { DetailsTabContent } from './DetailsTabContent';
import { useState } from 'react';
import ProjectPublishStageModal from './ProjectPublishStageModal';
import ProjectRecommendationModal from './ProjectRecommendationModal';
import { MatchTabContent } from './MatchingTabContent';
import { TeamMatchingTabContent } from './TeamMatchingTabContent';

export const ProjectDetail = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const [publishStageModalIsOpen, setPublishStageModalIsOpen] = useState(false);
  const [recommendProjectModalIsOpen, setRecommendProjectModalIsOpen] = useState(false);
  const {
    data: projectData,
    isSuccess,
    isLoading,
  } = AdminProjects.useGetReviewProject(parseInt(projectId));
  const pageActions: DetailPageAction[] = [
    {
      type: 'link',
      text: 'Edit',
      href: `/${projectId}/edit`,
    },
    {
      type: 'button',
      text: 'Update publish stage',
      onPress: () => setPublishStageModalIsOpen(true),
    },
  ];
  if (projectData?.publishingStage === 'published') {
    pageActions.push({
      type: 'button',
      text: 'Recommend',
      onPress: () => setRecommendProjectModalIsOpen(true),
    });
  }

  return (
    <>
      <AdminDetailPage
        title={projectData?.name || 'MovingWorlds Project'}
        isLoading={isLoading}
        isSuccess={isSuccess}
        tabs={[
          { id: 'Details', content: <DetailsTabContent projectData={projectData} /> },
          { id: 'Matching', content: <MatchTabContent projectId={parseInt(projectId)} /> },
          { id: 'Teams', content: <TeamMatchingTabContent projectId={parseInt(projectId)} /> },
        ]}
        pageActions={pageActions}
      />
      {publishStageModalIsOpen && projectData && (
        <ProjectPublishStageModal
          project={projectData}
          onClose={() => {
            setPublishStageModalIsOpen(false);
          }}
        />
      )}
      {recommendProjectModalIsOpen && projectData && (
        <ProjectRecommendationModal
          projectId={projectData.id}
          onClose={() => setRecommendProjectModalIsOpen(false)}
        />
      )}
    </>
  );
};
